const bezwypadkowy = {
    name: 'bezwypadkowe',
    names: ['bezwypadkowe'], // po-wypadkowe
    options: ['Tak'], // Nie
    t: 'Bezwypadkowy',
    type: 'all-checkbox',
}

export default bezwypadkowy